module.exports = __webpack_public_path__ + "img/logo-cefed-av-txt.0eea5e94.png";